<template>
    <div class="dflex" :style="{ 'margin-top': resultItem && resultItem.replayFlag ? '3px' : '' }">
        <img v-if="resultItem && resultItem.replayFlag"
            :src="resultItem.src && resultItem.src != null && resultItem.src != 'null' ? resultItem.src : emptyAvatar"
            mode="aspectFill" class="avatar" />
        <div class="comment-edit-box">

            <a-textarea v-model:value="comReq.content" :bordered="false"
                :placeholder="resultItem && resultItem.replayFlag ? '快来发表你评论吧~' : (resultItem && resultItem.placeholder ? '回复 ' + resultItem.placeholder : '快来发表你评论吧~')"
                :auto-size="{ minRows: 2, maxRows: 5 }" />
            <div class="comment-button" @click="toAdd">发表</div>

        </div>
    </div>
</template>
<script setup>
import { message } from "ant-design-vue/lib/components";
import { defineProps, ref, watch, onMounted, reactive } from "vue"
const showProps = defineProps(['resultItem', 'pId'])
const showEmits = defineEmits(['toAdd'])
const resultItem = ref(null)
const emptyAvatar = ref('https://enplus.oss-cn-guangzhou.aliyuncs.com/file/4d57c99d-ca12-4aec-bdfd-645d2b45c86d.png')
onMounted(() => {
    resultItem.value = showProps.resultItem
    comReq.pId = showProps.pId
    console.log(showProps, 'showProps')
})
const comReq = reactive({
    "pId": null, // 评论父id
    "content": null // 评论内容
})
const toAdd = () => {
    if (comReq.content && comReq.content.length > 0) {
        console.log(showProps.pId, 'showProps.pId')
        showEmits('toAdd', comReq)
        comReq.content = ""
    }
    else {
        message.warning('字数不能为0！')
    }



}



</script>
<style scoped>
.dflex {
    display: flex;
}

.comment-edit-box {
    width: 100%;
    position: relative;
    background: rgba(245, 246, 247, 0.8);
    border-radius: 8px;
    padding: 14px 0;
}

.comment-button:hover,
comment-button:focus {
    background-color: #08b9b9;

}

.comment-button {
    margin-left: auto;
    margin-right: 10px;
    cursor: pointer;

    width: 60px;
    height: 24px;
    background: #009688;
    color: #fff;
    border-radius: 16px;
    font-size: 14px;
    text-align: center;
    line-height: 24px;
    border: none;
}

.avatar {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 10px;
}
</style>